(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section-area.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section-area.js');

'use strict';

const {
  RetailerSection,
  RetailerGamePropType,
  RetailerInfoBox,
  RetailerSectionSkeleton
} = svs.components.tipsen;
const RetailerSectionArea = _ref => {
  let {
    branding,
    icon,
    isHidden,
    isLoading,
    loadCount,
    noResult,
    retailers,
    title
  } = _ref;
  if (isHidden) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "co-op-play-retail-section-header"
  }, React.createElement("h2", {
    className: "tipsen-header f-center f-medium"
  }, title)), React.createElement("div", {
    className: "co-op-play-retail-sections"
  }, retailers === null || retailers === void 0 ? void 0 : retailers.map(retailer => React.createElement(RetailerSection, {
    branding: branding,
    key: "global-".concat(retailer.id),
    retailer: retailer
  })), isLoading && [...Array(loadCount).keys()].map(key => React.createElement(RetailerSectionSkeleton, {
    key: key
  })), !isLoading && !(retailers !== null && retailers !== void 0 && retailers.length) && React.createElement(RetailerInfoBox, {
    icon: icon,
    text: noResult
  })));
};
RetailerSectionArea.defaultProps = {
  branding: 'sport',
  icon: 'rtp',
  isHidden: false,
  isLoading: false
};
setGlobal('svs.components.tipsen.RetailerSectionArea', RetailerSectionArea);

 })(window);